import { Input } from 'antd';
import React from 'react';

function formatarCEP(str){
	var re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/; // Pode usar ? no lugar do *

	if(re.test(str)){
		return str.replace(re,"$1.$2-$3");
	}

	return str;
}

export function InputCep({
  className,
  value,
  onChange,
  disabled,
  placeholder,
  prefix,
  onBlur
}){

  function handleChange(e) {
    const { value: cep } = e.target;
    onChange(formatarCEP(cep));
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      prefix={prefix}
      className={className}
      onBlur={onBlur}
      maxLength={10}
    />
  );

}
